'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isSubscriptionNeeded = isSubscriptionNeeded;
exports.logout_user_client = logout_user_client;
exports.isLoaded = isLoaded;
exports.load = load;
exports.login = login;
exports.saveSSODetail = saveSSODetail;
exports.register = register;
exports.check_edureka_user_exists = check_edureka_user_exists;
exports.logout = logout;
exports.facebook = facebook;
exports.google = google;
exports.getUserId = getUserId;
exports.subscription = subscription;
exports.createCookie = createCookie;
exports.readCookie = readCookie;
exports.updateUserSubscription = updateUserSubscription;
exports.updateLoadedEditor = updateLoadedEditor;
exports.forceSetUser = forceSetUser;

var _constants = require('../../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'redux-example/auth/LOAD';
var LOAD_SUCCESS = 'redux-example/auth/LOAD_SUCCESS';
var LOAD_FAIL = 'redux-example/auth/LOAD_FAIL';
var LOGIN = 'redux-example/auth/LOGIN';
var LOGIN_SUCCESS = 'redux-example/auth/LOGIN_SUCCESS';
var LOGIN_FAIL = 'redux-example/auth/LOGIN_FAIL';
var REGISTER = 'redux-example/auth/REGISTER';
var REGISTER_SUCCESS = 'redux-example/auth/REGISTER_SUCCESS';
var REGISTER_FAIL = 'redux-example/auth/REGISTER_FAIL';
var LOGOUT = 'redux-example/auth/LOGOUT';
var LOGOUT_SUCCESS = 'redux-example/auth/LOGOUT_SUCCESS';
var LOGOUT_FAIL = 'redux-example/auth/LOGOUT_FAIL';
var FACEBOOK = 'redux-example/auth/FACEBOOK';
var FACEBOOK_SUCCESS = 'redux-example/auth/FACEBOOK_SUCCESS';
var FACEBOOK_FAIL = 'redux-example/auth/FACEBOOK_FAIL';
var SUBSCRIPTION = 'redux-example/auth/SUBSCRIPTION';
var SUBSCRIPTION_SUCEESS = 'redux-example/auth/SUBSCRIPTION_SUCEESS';
var SUBSCRIPTION_FAIL = 'redux-example/auth/SUBSCRIPTION_FAIL';
var GET_USER_ID = 'redux-example/auth/GET_USER_ID';
var EDUREKA_USER_EXISTS = 'redux-example/auth/EDUREKA_USER_EXISTS';
var EDUREKA_USER_EXISTS_SUCCESS = 'redux-example/auth/EDUREKA_USER_EXISTS_SUCCESS';
var EDUREKA_USER_EXISTS_FAIL = 'redux-example/auth/EDUREKA_USER_EXISTS_FAIL';
var SUBSCRIPTION_NEEDED = 'auth/SUBSCRIPTION_NEEDED';
var UPDATE_USER_SUBSCRIPTION = 'UPDATE_USER_SUBSCRIPTION';
var UPDATE_USER_SUBSCRIPTION_SUCCESS = 'UPDATE_USER_SUBSCRIPTION_SUCCESS';
var UPDATE_USER_SUBSCRIPTION_FAIL = 'UPDATE_USER_SUBSCRIPTION_FAIL';
var UPDATE_USER_LOADED_EDITOR = 'UPDATE_USER_LOADED_EDITOR';
var UPDATE_USER_LOADED_EDITOR_SUCCESS = 'UPDATE_USER_LOADED_EDITOR_SUCCESS';
var UPDATE_USER_LOADED_EDITOR_FAIL = 'UPDATE_USER_LOADED_EDITOR_FAIL';
var TOKEN_VALIDATE = 'TOKEN_VALIDATE';
var TOKEN_VALIDATE_SUCCESS = 'TOKEN_VALIDATE_SUCCESS';
var TOKEN_VALIDATE_FAIL = 'TOKEN_VALIDATE_FAIL';
var FORCE_SET_USER = 'FORCE_SET_USER';
var SSO_DETAIL = "SSO_DETAIL";
var SSO_DETAIL_SUCCESS = "SSO_DETAIL_SUCCESS";
var SSO_DETAIL_FAIL = "SSO_DETAIL_FAIL";

var initialState = {
  user: false,
  loaded: false,
  checking_subscription: false,
  registerError: {},
  loginError: {},
  full_data: {},
  edureka_user_id: false,
  edureka_user_exists: false,
  edureka_user_exists_checking: false,
  subscription_needed: false,
  subscribed: false,
  sso_detail: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SUBSCRIPTION_NEEDED:
      return (0, _extends3.default)({}, state, {
        subscription_needed: action.key,
        subscribed: true,
        user: false
      });
      break;
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
      break;
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        user: action.result
      });
      break;
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
      break;
    case LOGIN:
      return (0, _extends3.default)({}, state, {
        loggingIn: true
      });
      break;
    case LOGIN_SUCCESS:
      createCookie('loggedIn', true, 999);
      // console.log('here');
      // console.log(action);
      return (0, _extends3.default)({}, state, {
        loggingIn: false,
        loaded: true,
        user: true
      });
    case SSO_DETAIL_SUCCESS:
      return (0, _extends3.default)({}, state, {
        sso_detail: true
      });
    case LOGIN_FAIL:
      if (action.error.detail === 'CSRF Failed: CSRF token missing or incorrect.') {
        createCookie('loggedIn', true, 999);
        return (0, _extends3.default)({}, state, {
          loggingIn: false,
          loaded: true,
          user: true,
          loginError: action.error
        });
      }
      return (0, _extends3.default)({}, state, {
        loggingIn: false,
        loaded: true,
        user: true,
        loginError: action.error
      });
    case FORCE_SET_USER:
      // console.log("login dispatched")
      createCookie('loggedIn', true, 999);
      return (0, _extends3.default)({}, state, {
        loggingIn: false,
        loaded: true,
        user: true
      });
    case REGISTER:
      return (0, _extends3.default)({}, state, {
        loggingIn: true
      });
    case REGISTER_SUCCESS:
      createCookie('loggedIn', true, 999);
      return (0, _extends3.default)({}, state, {
        loggingIn: false,
        loaded: true,
        user: true
      });
    case REGISTER_FAIL:
      return (0, _extends3.default)({}, state, {
        loggingIn: false,
        user: null,
        registerError: action.error
      });
    case LOGOUT:
      return (0, _extends3.default)({}, state, {
        loggingOut: true
      });
    case LOGOUT_SUCCESS:
      eraseCookie('loggedIn');
      return (0, _extends3.default)({}, state, {
        loaded: false,
        loggingOut: false,
        user: null
      });
    case LOGOUT_FAIL:
      return (0, _extends3.default)({}, state, {
        loggingOut: false,
        logoutError: action.error
      });
    case SUBSCRIPTION:
      return (0, _extends3.default)({}, state, {
        checking_subscription: true
      });
    case SUBSCRIPTION_SUCEESS:
      // User has been logged out from server in this case.
      // Subscription is hit on every request so using it to find out if user logged out.
      if (action.result == null) {
        eraseCookie('loggedIn');
        return (0, _extends3.default)({}, state, {
          loaded: false,
          loggingOut: false,
          user: null
        });
      }
      return (0, _extends3.default)({}, state, {
        checking_subscription: false,
        subscribed: action.result.valid
      });
    case SUBSCRIPTION_FAIL:
      return (0, _extends3.default)({}, state, {
        checking_subscription: false,
        subscribed_fail: true,
        user: null
      });
    case GET_USER_ID:
      // console.log(action);
      return (0, _extends3.default)({}, state, {
        edureka_user_id: action.user_id
      });
    case EDUREKA_USER_EXISTS:
      return (0, _extends3.default)({}, state, {
        edureka_user_exists_checking: true
      });
    case EDUREKA_USER_EXISTS_SUCCESS:
      if (!action.result.authenticated) {
        eraseCookie('loggedIn');
      }
      // console.log(action);
      return (0, _extends3.default)({}, state, {
        edureka_user_exists_checking: false,
        edureka_user_exists: action.result.success,
        loaded: action.result.authenticated,
        user: action.result.authenticated
      });
    case EDUREKA_USER_EXISTS_FAIL:
      return (0, _extends3.default)({}, state, {
        edureka_user_exists_checking: false,
        edureka_user_exists: false
      });
    case TOKEN_VALIDATE:
      return (0, _extends3.default)({}, state, {
        token_validate_checking: true,
        edureka_user_id: false
      });
    case TOKEN_VALIDATE_SUCCESS:
      // action.result = JSON.parse('{"status_code":200,"status_message":"Token is valid","data":{"id":"6991426"}}');
      if (action.result.data.id) {
        return (0, _extends3.default)({}, state, {
          token_validate_checking: false,
          edureka_user_id: action.result.data.id,
          full_data: action.result.data
          // user: false,
        });
      } else {
        window.location = initialState.redirect_url;
        return (0, _extends3.default)({}, state, {
          token_validate_checking: false,
          edureka_user_id: false,

          // loaded: true,
          user: false
        });
      }

    case TOKEN_VALIDATE_FAIL:
      window.location = initialState.redirect_url;
      return (0, _extends3.default)({}, state, {
        token_validate_checking: false,
        edureka_user_id: false
      });
    default:
      return state;
  }
}

function isSubscriptionNeeded(globalState) {
  return globalState.auth.subscription_needed;
}

function logout_user_client() {
  return {
    type: LOGOUT_SUCCESS
  };
}

function isLoaded(globalState) {
  var loggedIn = readCookie('loggedIn');
  // console.log(loggedIn);
  if (loggedIn === 'true') {
    globalState.auth.loaded = true;
    globalState.auth.user = true;
  }
  var URL = _constants.TARGET_URL;
  if (globalState.company.use_sso_login) {
    URL = globalState.company.target_url;
  }
  var data = checkAuthentication(URL + '/authenticated/');
  globalState.auth.user = data.authenticated;
  //Insert server check

  // return {
  //   types: [AUTHENTICATED_CHECK, AUTHENTICATED_CHECK_SUCCESS, AUTHENTICATED_CHECK_FAIL],
  //   promise: (client) => client.get('/authenticated/')
  // };
  // console.log(loggedIn, data.authenticated, globalState.auth, globalState.auth.loaded, globalState.auth.user);
  return data.authenticated && globalState.auth && globalState.auth.loaded && globalState.auth.user;
}

function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('/loadAuth');
    }
  };
}

function login(username, password) {
  return {
    types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
    promise: function promise(client) {
      return client.post('/rest-auth/login/', {
        data: {
          email: username,
          password: password
        }
      });
    }
  };
}

function saveSSODetail(data) {
  return {
    types: [SSO_DETAIL, SSO_DETAIL_SUCCESS, SSO_DETAIL_FAIL],
    promise: function promise(client) {
      return client.post('/save_sso_detail/', {
        data: data
      });
    }
  };
}

function register(username, password1, password2, email, api_key) {
  var data = {
    password1: password1,
    password2: password2,
    email: email,
    api_key: api_key
  };
  if (username) {
    data['username'] = username;
  }
  return {
    types: [REGISTER, REGISTER_SUCCESS, REGISTER_FAIL],
    promise: function promise(client) {
      return client.post('/rest-auth/registration/', {
        data: data
      });
    }
  };
}

function check_edureka_user_exists(username) {
  return {
    types: [EDUREKA_USER_EXISTS, EDUREKA_USER_EXISTS_SUCCESS, EDUREKA_USER_EXISTS_FAIL],
    promise: function promise(client) {
      return client.get('/edureka/user-exists/?user=' + username, {
        data: {
          user: username
        }
      });
    }
  };
}

function logout() {
  return {
    types: [LOGOUT, LOGOUT_SUCCESS, LOGOUT_FAIL],
    promise: function promise(client) {
      return client.get('/rest-auth/logout/');
    }
  };
}

function facebook(access_token) {
  return {
    types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
    promise: function promise(client) {
      return client.post('/rest-auth/facebook/', {
        data: {
          access_token: access_token,
          code: _constants.FACEBOOK_API_KEY
        }
      });
    }
  };
}

function google(access_token) {
  return {
    types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
    promise: function promise(client) {
      return client.post('/rest-auth/google/', {
        data: {
          access_token: access_token,
          code: _constants.GOOGLE_API_KEY
        }
      });
    }
  };
}

function getUserId(access_token, sso_endpoint, redirect_url) {
  // var data = httpGet(sso_endpoint, access_token);
  initialState.redirect_url = redirect_url;
  // console.log(access_token, sso_endpoint, redirect_url);
  return {
    types: [TOKEN_VALIDATE, TOKEN_VALIDATE_SUCCESS, TOKEN_VALIDATE_FAIL],
    promise: function promise(client) {
      return client.get(sso_endpoint, {
        header: {
          'auth-bearer': access_token
        }
      });
    }
  };
  //   var fetch_response =  fetch(sso_endpoint, {
  //    method: 'get',
  //    headers: new Headers({
  //      'auth-bearer': access_token
  //    }),
  //  }).then(res => res.json())
  // .then(response => {
  //   console.log('Success:', JSON.stringify(response))
  //   var data = JSON.parse('{"status_code":200,"status_message":"Token is valid","data":{"id":"6991426"}}');
  //   console.log(data);
  //   // if(false){
  //   if(data.data.id){
  //   // if(true){
  //   console.log('sdadas');
  //   console.log(data.data.id);
  //   // return_user_id(data.data.id)
  //     return {
  //       type: GET_USER_ID,
  //       user_id: data.data.id
  //       // user_id: 350444
  //     };
  //   }
  //   else {
  //     window.location.href = redirect_url;
  //     // return_user_id(false)
  //     return {
  //       type: GET_USER_ID,
  //       // user_id: data.data.id
  //       user_id: false
  //     };
  //   }
  //
  // })
  // .catch(error => {
  //   console.error('Error:', error);
  //   window.location.href = redirect_url
  // });
  // //console.log(data);
  // // if(false){
  // if(data.data.id){
  // // if(true){
  //   return {
  //     type: GET_USER_ID,
  //     user_id: data.data.id
  //     // user_id: 350444
  //   };
  // }
  // else {
  //   window.location.href = redirect_url;
  //   return {
  //     type: GET_USER_ID,
  //     // user_id: data.data.id
  //     user_id: false
  //   };
  // }
  // fetch_response.then(res => console.log(res))
  // console.log();
}

function subscription() {
  return {
    types: [SUBSCRIPTION, SUBSCRIPTION_SUCEESS, SUBSCRIPTION_FAIL],
    promise: function promise(client) {
      return client.get('/load-subscription-data/');
    }
  };
}

function createCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + value + expires + "; path=/";
}

function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1, c.length);
    }if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function eraseCookie(name) {
  createCookie(name, "", -1);
}

// For custom subscription of eukreka
function updateUserSubscription() {
  return {
    types: [UPDATE_USER_SUBSCRIPTION, UPDATE_USER_SUBSCRIPTION_SUCCESS, UPDATE_USER_SUBSCRIPTION_FAIL],
    promise: function promise(client) {
      return client.post('/update-user-subscription/');
    }
  };
}

// For custom subscription of OnlineTaiyari
function updateLoadedEditor() {
  return {
    types: [UPDATE_USER_LOADED_EDITOR, UPDATE_USER_LOADED_EDITOR_SUCCESS, UPDATE_USER_LOADED_EDITOR_FAIL],
    promise: function promise(client) {
      return client.post('/update-user-loaded-editor/');
    }
  };
}

function httpGet(theUrl, token) {
  // console.log(theUrl, token);
  var xmlHttp = new XMLHttpRequest();
  xmlHttp.open("GET", theUrl, false); // false for synchronous request
  xmlHttp.setRequestHeader('auth-bearer', token);
  xmlHttp.send(null);
  var response = xmlHttp.response;
  // console.log(response);
  return JSON.parse(response);
}

function checkAuthentication(theUrl) {
  var xmlHttp = new XMLHttpRequest();
  xmlHttp.open("GET", theUrl, false); // false for synchronous request
  xmlHttp.withCredentials = true;
  xmlHttp.send(null);
  var response = xmlHttp.response;
  return JSON.parse(response);
}

function forceSetUser() {
  // console.log("force set user")
  return {
    type: FORCE_SET_USER
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/auth.js
// module id = 112
// module chunks = 0